<div class="mx-html-field-container" *ngIf="!formReadonlyMode && !hidden"
     [formGroup]="form">
    <div class="mx-html-label">
        {{getLabel() | translate}}
    </div>
    <angular-editor
            [formControlName]="name"
            [config]="editorConfig"
            class="custom-angular-editor"
    ></angular-editor>
</div>

<mat-list-item class="mxs-readonly mxs-textarea-readonly" *ngIf="formReadonlyMode"
               [ngClass]="{'hidden': hidden}">
    <div class="mxs-readonly_label">{{label}}</div>
    <div class="mxs-readonly_textarea">
        <div class="readonly-html-field-block"
             [innerHTML]="getDisplayValue(form.get([name]).value) | mxSafeHtml"></div>
    </div>
</mat-list-item>